var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('appHeader'),_c('iframe',{staticStyle:{"height":"calc(142% - 10vw)","width":"100%","border":"0"},attrs:{"id":"myIframe","src":_vm.srcStr},on:{"onload":_vm.onloadFun}}),_vm._v(" iframe ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }